import { sessionStorageKeys } from '@/constants/sessionStorageKeys';
import { getTrackingData } from '@/utils/tracking/tracking';

export const logEventToConsole = (name: string, props?: Record<string, unknown>) => {
  const analyticsLoggingEnabled =
    sessionStorage.getItem(sessionStorageKeys.DEVTOOLS_ANALYTICS_LOGGING_ENABLED) === 'true';
  if (analyticsLoggingEnabled) {
    // eslint-disable-next-line no-console
    console.log(
      '%c Analytics Event %c' + name,
      'background: #4CAF50; color: white; font-weight: bold; padding: 4px 8px; border-radius: 3px;',
      'background: #2196F3; color: white; font-weight: bold; padding: 4px 8px; border-radius: 3px; margin-left: 8px;',
      props,
    );
  }
};

/**
 * Copies currency and value from ecommerce object to top level
 * so GTM receives them at the root level.
 */
export function copyEcommercePropertiesToTopLevel(props: Record<string, unknown>) {
  const result = { ...props };

  if ('ecommerce' in props && typeof props.ecommerce === 'object' && props.ecommerce !== null) {
    const ecommerce = props.ecommerce as Record<string, unknown>;

    // Copy currency to top level if it exists
    if ('currency' in ecommerce && !('currency' in result)) {
      result.currency = ecommerce.currency;
    }

    // Copy value as revenue to top level if it exists
    if ('value' in ecommerce && !('revenue' in result)) {
      result.revenue = ecommerce.value;
    }
  }

  return result;
}

/**
 * Determines affiliation from channel property or UTM tags.
 * Priority: channelName > utm_source > 'Organic'
 *
 * @returns Affiliation string - channel name, utm_source value, or 'Organic'
 */
export const determineAffiliation = (): string => {
  const { channelName, utmTags } = getTrackingData();

  if (channelName) {
    return channelName;
  }

  if (utmTags?.utm_source) {
    return utmTags.utm_source;
  }

  return 'Organic';
};
